import { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ShishaCharcoal from "./pages/ShishaCharcoal";
import BbqCharcoal from "./pages/BbqCharcoal";
import Sourcing from "./pages/Sourcing";
import WhyHaqila from "./pages/WhyHaqila";
import ExportProcess from "./pages/ExportProcess";
import About from "./pages/About";
import CommercialTerms from "./pages/CommercialTerms";
import PrivateLabel from "./pages/PrivateLabel";
import Documentation from "./pages/Documentation";
import Faq from "./pages/Faq";
import RequestQuote from "./pages/RequestQuote";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AdminLogin from "./pages/AdminLogin";
import AdminInquiries from "./pages/AdminInquiries";
import AdminDocuments from "./pages/AdminDocuments";
import AdminChatLeads from "./pages/AdminChatLeads";
import { LightboxProvider } from "./components/Lightbox";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-offwhite">
      <LightboxProvider>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/coconut-shell-shisha-charcoal" element={<ShishaCharcoal />} />
            <Route path="/products/bbq-coconut-charcoal" element={<BbqCharcoal />} />
            <Route path="/sourcing" element={<Sourcing />} />
            <Route path="/why-haqila" element={<WhyHaqila />} />
            <Route path="/export-process" element={<ExportProcess />} />
            <Route path="/about" element={<About />} />
            <Route path="/commercial-terms" element={<CommercialTerms />} />
            <Route path="/private-label" element={<PrivateLabel />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/request-a-quote" element={<RequestQuote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/inquiries" element={<AdminInquiries />} />
            <Route path="/admin/documents" element={<AdminDocuments />} />
            <Route path="/admin/chat-leads" element={<AdminChatLeads />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <ChatWidget />
        <WhatsAppButton />
        <Toaster position="top-center" richColors />
      </LightboxProvider>
    </div>
  );
}
